const SvgGranlupoLogo = () => (
	<svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1435.116 213.228">
		<defs>
			<clipPath clipPathUnits="userSpaceOnUse" id="granlupo-logo_svg__a">
				<path d="M0 2027.321h3000V0H0Z" />
			</clipPath>
		</defs>
		<g clipPath="url(#granlupo-logo_svg__a)" transform="matrix(1.33333 0 0 -1.33333 -1282.441 1430.53)">
			<path
				d="M0 0h39.152C33.568-15.075 21.074-22.612 1.675-22.612c-13.959 0-25.124 4.011-33.499 12.039-8.375 8.025-12.562 18.389-12.562 31.091 0 12.84 4.083 23.378 12.248 31.614 8.166 8.234 18.457 12.353 30.882 12.353 7.956 0 15.107-1.606 21.46-4.815 6.35-3.213 11.129-7.328 14.342-12.353L63.02 63.648c-6.281 10.05-15.111 18.143-26.485 24.287-11.378 6.14-23.904 9.212-37.582 9.212-21.496 0-39.675-7.4-54.54-22.193-14.865-14.796-22.298-32.871-22.298-54.226 0-21.356 7.502-39.362 22.507-54.017 15.003-14.656 33.882-21.984 56.634-21.984 20.937 0 38.21 6.523 51.819 19.576C66.684-22.648 73.488-5.165 73.488 16.749v12.563H0Z"
				style={{
					fill: '#100d3d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="translate(1043.466 972.001)"
			/>
			<path
				d="M0 0c-3.281-3.631-7.223-5.444-11.83-5.444h-25.124v37.687h25.124c4.607 0 8.549-1.816 11.83-5.444 3.278-3.631 4.92-8.096 4.92-13.4C4.92 8.093 3.278 3.628 0 0m30.986-11.41c4.953 7.606 7.433 15.876 7.433 24.809 0 13.956-4.887 25.822-14.656 35.593-9.772 9.769-21.637 14.656-35.593 14.656h-58.622V-82.91h33.498v48.155h15.912L6.595-82.91h36.011L11.41-29.102c8.094 4.187 14.62 10.082 19.576 17.692"
				style={{
					fill: '#100d3d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="translate(1202.384 1002.569)"
			/>
			<path
				d="M0 0h-33.498v-146.558h85.841v32.243H0Z"
				style={{
					fill: '#100d3d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="translate(1572.533 1066.217)"
			/>
			<path
				d="M0 0c0-13.681-7.677-20.518-23.03-20.518-15.357 0-23.031 6.837-23.031 20.518v96.31h-33.498V-2.931c0-15.356 5.303-27.568 15.911-36.64C-53.042-48.645-39.502-53.18-23.03-53.18c16.468 0 30.008 4.535 40.617 13.609 10.605 9.072 15.911 21.284 15.911 36.64V96.31H0Z"
				style={{
					fill: '#100d3d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="translate(1715.95 969.908)"
			/>
			<path
				d="M0 0c-3.35-3.631-7.61-5.444-12.772-5.444h-21.984v37.687h21.984c5.162 0 9.422-1.816 12.772-5.444 3.349-3.631 5.024-8.096 5.024-13.4C5.024 8.093 3.349 3.628 0 0m-12.772 63.648h-55.482V-82.91h33.498v46.061h21.984c14.374 0 26.518 4.884 36.43 14.656 9.909 9.769 14.865 21.634 14.865 35.592 0 13.956-4.956 25.822-14.865 35.593-9.912 9.769-22.056 14.656-36.43 14.656"
				style={{
					fill: '#100d3d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="translate(1834.054 1002.569)"
			/>
			<path
				d="M0 0c-8.165-8.097-18.32-12.143-30.464-12.143-12.143 0-22.296 4.046-30.462 12.143-8.165 8.094-12.248 18.562-12.248 31.405 0 12.84 4.083 23.309 12.248 31.406 8.166 8.093 18.319 12.143 30.462 12.143 12.144 0 22.299-4.05 30.464-12.143 8.165-8.097 12.248-18.566 12.248-31.406C12.248 18.562 8.165 8.094 0 0m23.554 85.632c-14.796 14.655-32.802 21.983-54.018 21.983-21.217 0-39.223-7.328-54.016-21.983-14.796-14.656-22.193-32.734-22.193-54.227 0-21.496 7.397-39.57 22.193-54.226 14.793-14.655 32.799-21.984 54.016-21.984 21.216 0 39.222 7.329 54.018 21.984C38.347-8.165 45.746 9.909 45.746 31.405c0 21.493-7.399 39.571-22.192 54.227"
				style={{
					fill: '#100d3d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="translate(1988.672 961.533)"
			/>
			<path
				d="M0 0a2.853 2.853 0 1 1 0 5.706 2.844 2.844 0 0 1-2.695-1.955c.043-.032.09-.061.132-.093V1.621A2.846 2.846 0 0 1 0 0"
				style={{
					fill: '#100d3d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="translate(1409.486 964.429)"
			/>
			<path
				d="m0 0 17.168 53.808L34.336 0Zm182.568 12.562-56.53 79.56h-25.124V9.057c-2.109.52-4.503.841-7.274.841h-.017c-7.088-.004-15.8-3.454-22.974-12.264L38.523 92.122h-42.71l-49.83-146.558h41.282c.315 2.137 1.595 8.3 6.405 14.848-7.236 6.715-10.025 19.617-10.025 19.617 5.033-6.894 12.447-10.303 17.528-11.923 4.604 3.619 10.701 6.891 18.811 9.11 7.37 2.016 14.264 2.667 20.972 2.156l10.758-33.808H88.353L79.926-29.65c7.243 2.6 7.934 11.966 7.934 11.966l-.025-.076-.009-.026a14.256 14.256 0 0 0-.257-.679c-.837-2.088-3.532-7.724-8.489-8.696-1.819-.357-3.938-.091-6.385 1.218-2.852 1.527-4.727 3.874-3.839 6.245.266.711.557 1.42.861 2.127.075.173.153.345.229.518.265.597.542 1.193.833 1.784.056.113.11.228.167.341a48.192 48.192 0 0 0 2.36 4.168 42.016 42.016 0 0 0 3.142 4.34c.308.369.62.731.94 1.085.094.105.191.206.286.309a32.61 32.61 0 0 0 1.668 1.678c.158.148.314.301.474.445.265.237.535.464.807.69.235.196.473.387.713.575.249.194.498.388.752.572.45.326.907.637 1.372.929.189.118.382.223.573.335.376.221.756.432 1.141.629a20.274 20.274 0 0 0 1.889.846c.154.06.305.128.461.184.572.206 1.155.383 1.745.533.159.04.32.07.481.106.468.106.942.193 1.421.261.181.026.362.053.545.073.629.069 1.264.117 1.91.117 14.098.007 14.745-9.76 20.075-10.98 2.62-.6 9.486-.663 12.321-.65a2.335 2.335 0 0 0 2.32-2.669c-.59-4.233-2.598-12.186-10.542-14.568-10.712-3.211-17.398 2.294-21.321-5.909-3.673-7.681-1.693-14.181-1.693-14.181s12.342-.557 12.635-8.426h26.991v79.56l56.531-79.56h25.122V92.122h-33.497z"
				style={{
					fill: '#100d3d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="translate(1306.01 974.095)"
			/>
		</g>
	</svg>
)

export default SvgGranlupoLogo
